const { useSelector } = require('react-redux');
const {
  get_configuration_config,
} = require('@managers/remoteConfigurationsManager');
const { GLOBAL_SEARCH_CONFIG_NAME } = require('./GlobalSearch.types');

/**
 * Rollout gate for the global search — entirely server-side.
 *
 * Open when the `global_search` Remote Configuration resolves true for this
 * user. `GET /remote_user_configurations` picks the effective value per
 * caller (users_email[email] > environments[env] > default_value) and returns
 * it as `default_value`; get_configuration_config then lets a farming unit or
 * distribution override refine it further.
 *
 * No configuration means no feature: get_configuration_config returns false
 * for an unknown name, which is the correct default for a rollout gate.
 */
const useGlobalSearchAccess = () => {
  const configurationData = useSelector((state) => state.configuration_data);
  const farmingUnitName = useSelector(
    (state) => state.distribution_data?.selected_entities?.farming_unit?.name,
  );
  const distributionName = useSelector(
    (state) => state.distribution_data?.selected_entities?.distribution?.name,
  );

  return Boolean(
    get_configuration_config(
      configurationData ?? {},
      GLOBAL_SEARCH_CONFIG_NAME,
      farmingUnitName,
      distributionName,
    ),
  );
};

module.exports = useGlobalSearchAccess;
